module.exports = __webpack_public_path__ + "media/assets/img/order/successful_order-4eb527620d2d4875e504385378afffb3.svg";